import BaseService from './BaseService'

export class OrderService extends BaseService {
// eslint-disable-next-line no-useless-constructor
  constructor (axios) {
    super(axios)
  }
  // 当前提交订单
  loadCurrentOrders (orderIds) {
    const url = '/hy-sb-order/purchaseOrder/getOrdersByOrderIds'
    return this.httpTool.post(url,
      { orderIds: orderIds })
      .then((response) => {
        const { content = [] } = response
        let orders = []
        orders = this.dealOrders(content)
        return orders
      })
  }
  // 查询所有订单
  loadAllOrders (searchInfo) {
    const url = '/hy-sb-order/purchaseOrder/list'
    return this.httpTool.request({ url: url,
      data: searchInfo,
      method: 'post' })
      .then((response) => {
        const { content: { count, index, pages, size, list = [] }} = response
        const pageInfo = { count: count, index: index, pages: pages, size: size }
        let orders = []
        if (response.code === '0') {
          orders = this.dealOrders(list)
        }
        return { orders: orders, pageInfo: pageInfo }
      })
  }
  // 处理所有订单
  dealOrders (orders) {
    const orderInfos = []
    orders.forEach(order => {
      const orderInfo = {};
      ({ createTime: orderInfo.createTime, logisShopName: orderInfo.shopName, orderId: orderInfo.id,
        total: orderInfo.total, payType: orderInfo.payType, purchaseOrderItemDtos: orderInfo.items = [], status: orderInfo.status } = order)
      orderInfo.show = true
      orderInfo.items = this.dealOrderItems(orderInfo.items)
      orderInfos.push(orderInfo)
    })
    return orderInfos
  }
  // 处理订单包含的商品
  dealOrderItems (items) {
    var itemsAfterDeal = []
    items.forEach(item => {
      var itemInfo = {};
      ({ barcode: itemInfo.lotNumber, basicUnit: itemInfo.basicUnit, expiryTime: itemInfo.expiryTime, transferPrice: itemInfo.showPrice,
        imgs: [itemInfo.image, ...itemInfo.otherImg], largeScale: itemInfo.largeScale, licenseNumber: itemInfo.licenseNumber,
        manufacturer: itemInfo.maker, name: itemInfo.name, quantity: itemInfo.num,
        title1: itemInfo.commonName, title2: itemInfo.norm } = item)
      itemInfo.count = (itemInfo.showPrice * itemInfo.num).toFixed(2)
      itemInfo.showPrice = itemInfo.showPrice.toFixed(2)
      itemsAfterDeal.push(itemInfo)
    })
    return itemsAfterDeal
  }
}
